import { render, staticRenderFns } from "./details-report.vue?vue&type=template&id=76bc1310&scoped=true"
import script from "./details-report.ts?vue&type=script&lang=ts&external"
export * from "./details-report.ts?vue&type=script&lang=ts&external"
import style0 from "./details-report.less?vue&type=style&index=0&id=76bc1310&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bc1310",
  null
  
)

export default component.exports